var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_36202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.68661 0.5 0 3.18661 0 6.5C0 9.81339 2.68661 12.5 6 12.5C9.31339 12.5 12 9.81339 12 6.5C12 3.18661 9.31339 0.5 6 0.5ZM6 11.4821C3.24911 11.4821 1.01786 9.25089 1.01786 6.5C1.01786 3.74911 3.24911 1.51786 6 1.51786C8.75089 1.51786 10.9821 3.74911 10.9821 6.5C10.9821 9.25089 8.75089 11.4821 6 11.4821Z",
    fill: "#E4001C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35693 8.85714C5.35693 9.02764 5.42466 9.19115 5.54522 9.31171C5.66578 9.43227 5.8293 9.5 5.99979 9.5C6.17029 9.5 6.3338 9.43227 6.45436 9.31171C6.57492 9.19115 6.64265 9.02764 6.64265 8.85714C6.64265 8.68665 6.57492 8.52313 6.45436 8.40258C6.3338 8.28202 6.17029 8.21429 5.99979 8.21429C5.8293 8.21429 5.66578 8.28202 5.54522 8.40258C5.42466 8.52313 5.35693 8.68665 5.35693 8.85714ZM5.67836 7.35714H6.32122C6.38015 7.35714 6.42836 7.30893 6.42836 7.25V3.60714C6.42836 3.54821 6.38015 3.5 6.32122 3.5H5.67836C5.61943 3.5 5.57122 3.54821 5.57122 3.60714V7.25C5.57122 7.30893 5.61943 7.35714 5.67836 7.35714Z",
    fill: "#E4001C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_36202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureIcon);
export default __webpack_public_path__ + "static/media/failure-icon.ecf8929278db5a4ff7d5274372cc1786.svg";
export { ForwardRef as ReactComponent };